var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-menu-list"
  }, [_vm._l((_vm.currentPathArr), function(item, index) {
    return (!item.hidden && index < _vm.maxItem) ? _c('div', {
      key: item.name,
      attrs: {
        "href": item.path
      }
    }, [(item.children.length > 0) ? _c('MenuItem', {
      staticClass: "top-menu-item",
      attrs: {
        "name": item.path.split('/')[1]
      }
    }, [_c('svg-icon', {
      key: item.path,
      staticClass: "top-menu-icon",
      attrs: {
        "icon-class": item.icon
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "top-menu-title"
    }, [_vm._v(_vm._s(item.title))])], 1) : _vm._e(), _vm._v(" "), (item.children.length <= 0) ? _c('MenuItem', {
      staticClass: "top-menu-item top-menu-link-item",
      attrs: {
        "name": item.path.split('/')[1]
      }
    }, [_c('router-link', {
      staticStyle: {
        "display": "inline-block",
        "height": "100%",
        "width": "100%"
      },
      attrs: {
        "tag": "span",
        "to": item.path + '/' + item.children[0].path
      }
    }, [_c('svg-icon', {
      key: item.path,
      staticClass: "top-menu-link-icon",
      attrs: {
        "icon-class": item.icon
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "top-menu-title"
    }, [_vm._v(_vm._s(item.title))])], 1)], 1) : _vm._e()], 1) : _vm._e()
  }), _vm._v(" "), (_vm.maxItem !== _vm.currentPathArr.length && _vm.maxItem <= _vm.currentPathArr.length) ? _c('Submenu', {
    attrs: {
      "name": "group"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "stats-bars"
    }
  })], 1), _vm._v(" "), _c('MenuGroup', {
    attrs: {
      "title": "列表"
    }
  }, _vm._l((_vm.currentPathArr), function(item, index) {
    return (!item.hidden && index >= _vm.maxItem) ? _c('div', {
      key: item.name,
      attrs: {
        "href": item.path
      }
    }, [(item.children.length > 0) ? _c('MenuItem', {
      attrs: {
        "name": item.path.split('/')[1]
      }
    }, [_c('Icon', {
      key: item.path,
      staticStyle: {
        "width": "20px"
      },
      attrs: {
        "type": item.icon,
        "size": _vm.iconSize
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "dropdownItemIcon"
    }, [_vm._v(_vm._s(item.title))])], 1) : _vm._e(), _vm._v(" "), (item.children.length <= 0) ? _c('MenuItem', {
      attrs: {
        "name": item.path.split('/')[1]
      }
    }, [_c('router-link', {
      staticStyle: {
        "display": "inline-block",
        "height": "100%",
        "width": "100%"
      },
      attrs: {
        "tag": "span",
        "to": item.path + '/' + item.children[0].path
      }
    }, [_c('Icon', {
      key: item.path,
      staticStyle: {
        "width": "20px"
      },
      attrs: {
        "type": item.icon,
        "size": _vm.iconSize
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "dropdownItemIcon"
    }, [_vm._v(_vm._s(item.title))])], 1)], 1) : _vm._e()], 1) : _vm._e()
  }), 0)], 2) : _vm._e()], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a642c74","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/BreadcrumbNav.vue
// module id = z3aJ
// module chunks = 166